var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCleaning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 52 52",
    style: {
      enableBackground: "new 0 0 52 52"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:#232A2E;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M50.48,30.85v0.68c0,0.63-0.51,1.14-1.14,1.14H38.5c-0.64,0-1.16-0.51-1.16-1.14v-0.68 c0-2.25,2.42-4.79,2.85-5.22l0.04-0.04c0.09-0.09,0.21-0.15,0.34-0.15l6.7,0.01c0.13,0,0.26,0.05,0.35,0.14 C47.91,25.89,50.48,28.55,50.48,30.85z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "32.45,44.22 18.87,44.22 18.87,15.71 32.45,15.7  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M32.45,44.73H18.88c-0.28,0-0.51-0.23-0.51-0.51V15.71c0-0.28,0.23-0.51,0.51-0.51l13.57-0.01h0 c0.14,0,0.27,0.05,0.36,0.15c0.1,0.1,0.15,0.23,0.15,0.36v28.52C32.96,44.5,32.73,44.73,32.45,44.73z M19.39,43.71h12.55v-27.5 l-12.55,0.01V43.71z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M49.76,32.95H38.09c-0.69,0-1.25-0.55-1.25-1.23V31c0-2.43,2.61-5.16,3.07-5.63 c0.01-0.02,0.03-0.03,0.04-0.04c0.1-0.1,0.23-0.15,0.36-0.15c0,0,0,0,0,0l7.22,0.01c0.14,0,0.28,0.05,0.37,0.15 c0.32,0.32,3.09,3.18,3.09,5.66v0.73C50.99,32.4,50.44,32.95,49.76,32.95z M40.54,26.19c-1.31,1.34-2.67,3.37-2.67,4.8v0.73 c0,0.11,0.1,0.2,0.22,0.2h11.67c0.12,0,0.2-0.09,0.2-0.2V31c0-1.41-1.34-3.43-2.64-4.79L40.54,26.19z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "40.08,14.82 34.91,29.86 34.91,21.5 37.51,13.94  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M50.49,45.12v1.44c0,0.43-0.36,0.79-0.79,0.79H22.01l-3.13-3.13h13.01V16.49c0-0.43-0.35-0.78-0.78-0.78H2.29 c-0.43,0-0.78-0.36-0.78-0.79v-1.45c0-0.43,0.35-0.78,0.78-0.78h29.48c1.73,0,3.13,1.4,3.13,3.13v27.72 c0,0.44,0.36,0.79,0.79,0.79h14C50.13,44.33,50.49,44.68,50.49,45.12z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M49.7,47.87H22.01c-0.14,0-0.27-0.05-0.36-0.15l-3.13-3.13c-0.15-0.15-0.19-0.37-0.11-0.56 c0.08-0.19,0.27-0.32,0.47-0.32h12.5V16.49c0-0.15-0.12-0.27-0.27-0.27H2.29c-0.71,0-1.29-0.58-1.29-1.3v-1.45 c0-0.71,0.58-1.29,1.29-1.29h29.48c2.01,0,3.64,1.64,3.64,3.64v27.72c0,0.15,0.12,0.28,0.28,0.28h14c0.72,0,1.3,0.58,1.3,1.3v1.44 C51,47.28,50.42,47.87,49.7,47.87z M22.22,46.84H49.7c0.15,0,0.28-0.13,0.28-0.28v-1.44c0-0.15-0.12-0.28-0.28-0.28h-14 c-0.72,0-1.3-0.58-1.3-1.3V15.82c0-1.45-1.18-2.62-2.62-2.62H2.29c-0.15,0-0.27,0.12-0.27,0.27v1.45c0,0.15,0.12,0.28,0.27,0.28 h28.82c0.71,0,1.29,0.58,1.29,1.29v27.73c0,0.28-0.23,0.51-0.51,0.51H20.11L22.22,46.84z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000106130880543749778910000016530216664962099133_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.42,
    y: 15.7,
    className: "st1",
    width: 14.1,
    height: 3.36
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M16.53,19.57H2.42c-0.28,0-0.51-0.23-0.51-0.51v-3.36c0-0.28,0.23-0.51,0.51-0.51h14.1 c0.28,0,0.51,0.23,0.51,0.51v3.36C17.04,19.34,16.81,19.57,16.53,19.57z M2.94,18.55h13.08v-2.33H2.94V18.55z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 5.63,
    y: 15.7,
    className: "st0",
    width: 10.89,
    height: 3.36
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M16.52,19.57H5.63c-0.28,0-0.51-0.23-0.51-0.51V15.7c0-0.28,0.23-0.51,0.51-0.51h10.89 c0.28,0,0.51,0.23,0.51,0.51v3.36C17.03,19.34,16.81,19.57,16.52,19.57z M6.14,18.55h9.87v-2.33H6.14V18.55z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16.52,19.06l-1.15,23.29c-0.06,1.25-1.1,2.23-2.34,2.23h-3.9c-1.26,0-2.29-0.98-2.35-2.23L5.63,19.06H16.52z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M13.03,45.09h-3.9c-1.53,0-2.79-1.19-2.87-2.72L5.12,19.08c-0.01-0.14,0.04-0.28,0.14-0.38 c0.1-0.1,0.23-0.16,0.37-0.16h10.89c0.14,0,0.27,0.06,0.37,0.16c0.1,0.1,0.15,0.24,0.14,0.38l-1.15,23.29 C15.81,43.9,14.56,45.09,13.03,45.09z M6.17,19.57l1.12,22.75c0.05,0.98,0.86,1.75,1.84,1.75h3.9c0.98,0,1.79-0.77,1.83-1.75 l1.12-22.75H6.17z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000182521352985481091960000014340184843563530418_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.87,
    y: 28.49,
    className: "st0",
    width: 13.02,
    height: 2.94
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M31.89,31.94H18.87c-0.28,0-0.51-0.23-0.51-0.51v-2.94c0-0.28,0.23-0.51,0.51-0.51h13.02 c0.28,0,0.51,0.23,0.51,0.51v2.94C32.4,31.71,32.17,31.94,31.89,31.94z M19.39,30.92h11.99V29H19.39V30.92z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000111884135509233327810000011467583991568312971_"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 18.88,
    cy: 47.35,
    r: 3.13
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M18.88,51c-2.01,0-3.65-1.64-3.65-3.65c0-2.01,1.64-3.65,3.65-3.65c2.01,0,3.65,1.64,3.65,3.65 C22.52,49.36,20.89,51,18.88,51z M18.88,44.73c-1.45,0-2.62,1.18-2.62,2.62c0,1.45,1.18,2.62,2.62,2.62 c1.45,0,2.62-1.18,2.62-2.62C21.5,45.9,20.32,44.73,18.88,44.73z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000080180826757439599840000014251268538247300527_"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 46.11,
    cy: 48.57,
    r: 1.91
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M46.11,51c-1.34,0-2.42-1.09-2.42-2.42c0-1.34,1.09-2.42,2.42-2.42c1.34,0,2.42,1.09,2.42,2.42 C48.53,49.91,47.44,51,46.11,51z M46.11,47.17c-0.77,0-1.4,0.63-1.4,1.4c0,0.77,0.63,1.4,1.4,1.4c0.77,0,1.4-0.63,1.4-1.4 C47.51,47.8,46.88,47.17,46.11,47.17z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000090276654927577717020000010460222463915801743_"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "49.77,31.56 48.53,44.33 39.32,44.33 38.08,31.56  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M48.53,44.85h-9.2c-0.26,0-0.48-0.2-0.51-0.46l-1.24-12.77c-0.01-0.14,0.03-0.29,0.13-0.39 c0.1-0.11,0.23-0.17,0.38-0.17h11.69c0.14,0,0.28,0.06,0.38,0.17c0.1,0.11,0.14,0.25,0.13,0.39l-1.24,12.77 C49.01,44.65,48.79,44.85,48.53,44.85z M39.79,43.82h8.27l1.14-11.75H38.65L39.79,43.82z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M49.45,34.91l-0.3,2.99c-0.13,0.03-0.29,0.05-0.47,0.05c-1.19,0-1.19-0.85-2.38-0.85 c-1.2,0-1.2,0.85-2.39,0.85c-1.19,0-1.19-0.85-2.39-0.85c-1.18,0-1.18,0.85-2.38,0.85c-0.17,0-0.33-0.01-0.46-0.05l-0.29-2.99 c0.19,0.09,0.43,0.16,0.75,0.16c1.2,0,1.2-0.87,2.38-0.87c1.2,0,1.2,0.87,2.39,0.87c1.19,0,1.19-0.87,2.39-0.87 c1.19,0,1.19,0.87,2.38,0.87C49.01,35.07,49.24,35,49.45,34.91z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000154387067190611256170000010061373629211795845_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M26.67,27.78c0.07,0.24,0.15,0.48,0.24,0.71h-3.06c0.08-0.21,0.16-0.42,0.22-0.64 c0.34-1.17,0.12-2.47-0.65-3.41c-0.35-0.43-0.56-0.98-0.56-1.58c0-1.6,1.5-2.85,3.15-2.45c0.9,0.22,1.63,0.97,1.83,1.88 c0.17,0.76-0.01,1.48-0.41,2.04C26.71,25.34,26.34,26.58,26.67,27.78z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M26.91,29h-3.06c-0.17,0-0.33-0.08-0.42-0.23c-0.1-0.14-0.11-0.32-0.05-0.48c0.08-0.19,0.14-0.39,0.2-0.59 c0.3-1.03,0.08-2.16-0.55-2.95c-0.43-0.54-0.67-1.21-0.67-1.9c0-0.94,0.43-1.81,1.17-2.39c0.74-0.58,1.69-0.78,2.61-0.55 c1.1,0.27,1.96,1.16,2.21,2.26c0.19,0.87,0.02,1.74-0.49,2.45c-0.7,0.98-0.95,2.05-0.68,3.01l0,0c0.06,0.22,0.13,0.44,0.22,0.66 c0.06,0.16,0.04,0.34-0.05,0.48C27.24,28.92,27.08,29,26.91,29z M24.57,27.98h1.63c-0.01-0.02-0.01-0.04-0.02-0.06 c-0.35-1.26-0.05-2.64,0.84-3.88c0.34-0.47,0.45-1.05,0.32-1.63c-0.16-0.72-0.74-1.31-1.45-1.49c-0.62-0.15-1.25-0.02-1.74,0.37 c-0.49,0.39-0.77,0.96-0.77,1.59c0,0.46,0.15,0.9,0.45,1.25C24.66,25.16,24.95,26.64,24.57,27.98z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000026845499233934847780000015467754910966843289_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M25.38,20.86c-0.28,0-0.51-0.23-0.51-0.51v-1.9c0-0.28,0.23-0.51,0.51-0.51c0.28,0,0.51,0.23,0.51,0.51v1.9 C25.89,20.63,25.66,20.86,25.38,20.86z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000029749114266509380450000001666924711440559749_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M22.52,19.34l0.38-0.38c0.33-0.33,0.78-0.52,1.24-0.52h2.48c0.47,0,0.91-0.19,1.24-0.52l0.38-0.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M22.52,19.85c-0.13,0-0.26-0.05-0.36-0.15c-0.2-0.2-0.2-0.52,0-0.72l0.38-0.38c0.43-0.43,1-0.66,1.61-0.66 h2.48c0.33,0,0.65-0.13,0.88-0.37l0.38-0.38c0.2-0.2,0.52-0.2,0.72,0s0.2,0.52,0,0.72l-0.38,0.38c-0.42,0.42-1.01,0.67-1.61,0.67 h-2.48c-0.33,0-0.65,0.13-0.88,0.37l-0.38,0.38C22.78,19.8,22.65,19.85,22.52,19.85z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000119829284866876213010000007522397996239643308_"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 25.38,
    y1: 36.79,
    x2: 25.38,
    y2: 34.46
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M25.38,37.3c-0.28,0-0.51-0.23-0.51-0.51v-2.33c0-0.28,0.23-0.51,0.51-0.51s0.51,0.23,0.51,0.51v2.33 C25.89,37.07,25.67,37.3,25.38,37.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000126287240063170360840000012805077756356143264_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M28.01,35.28l-0.35-0.35c-0.3-0.3-0.71-0.47-1.14-0.47h-2.28c-0.43,0-0.84-0.17-1.14-0.47l-0.35-0.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M28.01,35.79c-0.13,0-0.26-0.05-0.36-0.15l-0.35-0.35c-0.21-0.21-0.48-0.32-0.78-0.32h-2.28 c-0.56,0-1.11-0.23-1.5-0.62L22.4,34c-0.2-0.2-0.2-0.52,0-0.72c0.2-0.2,0.52-0.2,0.72,0l0.35,0.35c0.2,0.2,0.49,0.32,0.78,0.32 h2.28c0.57,0,1.1,0.22,1.5,0.62l0.35,0.34c0.2,0.2,0.2,0.52,0,0.72C28.27,35.74,28.14,35.79,28.01,35.79z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000143618162456317809820000001637312219897296561_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M27.26,38.67v5.55H23.5v-5.55c0-1.04,0.84-1.88,1.88-1.88h0C26.42,36.79,27.26,37.63,27.26,38.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M27.26,44.73H23.5c-0.28,0-0.51-0.23-0.51-0.51v-5.55c0-1.32,1.07-2.39,2.39-2.39c1.32,0,2.39,1.07,2.39,2.39 v5.55C27.77,44.5,27.54,44.73,27.26,44.73z M24.01,43.7h2.74v-5.04c0-0.75-0.61-1.37-1.37-1.37c-0.75,0-1.37,0.61-1.37,1.37V43.7z "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000147202776649814335900000007759850615975107456_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M42.91,12.61c-0.6,1.73-2.48,2.65-4.2,2.06c-1.73-0.6-2.65-2.48-2.05-4.21L42.91,12.61z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M39.78,15.36c-0.42,0-0.84-0.07-1.24-0.21c-1.99-0.69-3.06-2.87-2.37-4.86c0.04-0.13,0.14-0.23,0.26-0.29 c0.12-0.06,0.26-0.07,0.39-0.02l6.26,2.15c0.27,0.09,0.41,0.38,0.32,0.65c-0.33,0.97-1.02,1.74-1.94,2.19 C40.92,15.23,40.35,15.36,39.78,15.36z M37.01,11.12c-0.2,1.31,0.56,2.61,1.86,3.06c0.71,0.24,1.46,0.19,2.13-0.13 c0.52-0.25,0.93-0.65,1.21-1.14L37.01,11.12z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000029723954666724150670000015575979410502121128_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M34.04,8.23l0.41-1.18l12.29,4.23l-0.41,1.18c-0.23,0.65-0.94,1-1.59,0.78l-9.92-3.42 C34.16,9.6,33.81,8.88,34.04,8.23z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000179644870598039516230000016528734877974013097_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000029048152506594112330000018219527644143298950_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M46.74,11.28l-2.46-0.85L47.5,5.9l2.26,0.78c0.55,0.19,0.71,0.89,0.3,1.3L46.74,11.28z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M46.74,11.8c-0.06,0-0.11-0.01-0.17-0.03l-2.46-0.85c-0.15-0.05-0.27-0.17-0.32-0.33s-0.02-0.32,0.07-0.45 l3.22-4.54c0.13-0.18,0.37-0.26,0.58-0.19l2.26,0.78c0.43,0.15,0.74,0.5,0.84,0.93c0.1,0.44-0.03,0.89-0.35,1.21l-3.32,3.31 C47,11.74,46.87,11.8,46.74,11.8z M45.09,10.18l1.51,0.52l3.1-3.08c0.1-0.1,0.08-0.21,0.07-0.25c-0.01-0.04-0.05-0.15-0.18-0.2 l-1.9-0.65L45.09,10.18z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000071560952721219351910000004708769780543602350_"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "44.28,10.44 41.82,9.59 44.05,4.71 47.5,5.9  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M44.28,10.95c-0.06,0-0.11-0.01-0.17-0.03l-2.46-0.85c-0.14-0.05-0.25-0.15-0.3-0.28 c-0.06-0.13-0.05-0.28,0.01-0.41l2.23-4.88c0.11-0.24,0.38-0.36,0.63-0.27l3.45,1.19c0.15,0.05,0.27,0.17,0.32,0.33 c0.05,0.15,0.02,0.32-0.07,0.45l-3.22,4.54C44.6,10.87,44.44,10.95,44.28,10.95z M42.52,9.29l1.56,0.54l2.6-3.67l-2.36-0.81 L42.52,9.29z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000121979116140703833780000006760417108564137891_"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "41.82,9.59 39.36,8.74 40.61,3.52 44.05,4.71  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M41.82,10.1c-0.06,0-0.11-0.01-0.17-0.03l-2.46-0.85c-0.25-0.09-0.39-0.35-0.33-0.6l1.24-5.22 c0.03-0.14,0.12-0.26,0.25-0.33c0.13-0.07,0.28-0.08,0.41-0.04l3.45,1.19c0.14,0.05,0.25,0.15,0.3,0.28 c0.06,0.13,0.05,0.28-0.01,0.41L42.29,9.8C42.2,9.99,42.02,10.1,41.82,10.1z M39.97,8.41l1.58,0.54l1.81-3.94l-2.38-0.82 L39.97,8.41z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000011711045360126089980000005034202742727736199_"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "39.36,8.74 36.9,7.9 37.16,2.34 40.61,3.52  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M39.36,9.26c-0.06,0-0.11-0.01-0.17-0.03l-2.46-0.85c-0.21-0.07-0.36-0.28-0.34-0.51l0.25-5.56 c0.01-0.16,0.09-0.31,0.22-0.4c0.13-0.09,0.3-0.11,0.45-0.06l3.45,1.19c0.25,0.09,0.39,0.35,0.33,0.6l-1.24,5.22 C39.83,9,39.73,9.12,39.61,9.19C39.53,9.23,39.45,9.26,39.36,9.26z M37.43,7.54l1.56,0.54L40,3.86l-2.36-0.81L37.43,7.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000047776595198267110630000016648097653004257983_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M36.9,7.9l-2.46-0.85L33.86,2.4c-0.07-0.58,0.48-1.03,1.03-0.84l2.26,0.78L36.9,7.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M36.9,8.41c-0.06,0-0.11-0.01-0.17-0.03l-2.46-0.85c-0.18-0.06-0.32-0.23-0.34-0.42l-0.58-4.65 c-0.06-0.45,0.12-0.88,0.47-1.17c0.35-0.28,0.81-0.36,1.24-0.22l2.26,0.78c0.21,0.07,0.36,0.28,0.34,0.51l-0.25,5.56 c-0.01,0.16-0.09,0.31-0.22,0.4C37.1,8.38,37,8.41,36.9,8.41z M34.91,6.67l1.51,0.52l0.2-4.49l-1.9-0.65 C34.6,2,34.5,2.06,34.47,2.09c-0.03,0.03-0.11,0.11-0.1,0.24L34.91,6.67z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000182516090823049005170000016331459592154537094_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M27.84,2.12v1.6H16.18v-1.6c0-0.33,0.27-0.6,0.6-0.6h10.45C27.57,1.52,27.84,1.79,27.84,2.12z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M27.84,4.23H16.18c-0.28,0-0.51-0.23-0.51-0.51v-1.6c0-0.62,0.5-1.12,1.12-1.12h10.45 c0.62,0,1.12,0.5,1.12,1.12v1.6C28.36,4,28.13,4.23,27.84,4.23z M16.69,3.21h10.64V2.12c0-0.05-0.04-0.09-0.09-0.09H16.78 c-0.05,0-0.09,0.04-0.09,0.09V3.21z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000126294987847373057200000010388732670201002421_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M28.59,5.04V4.32c0-0.33-0.27-0.6-0.6-0.6H16.04c-0.33,0-0.6,0.27-0.6,0.6v0.72c0,1.24,1.01,2.25,2.25,2.25 h8.66C27.58,7.29,28.59,6.28,28.59,5.04z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M26.34,7.8h-8.66c-1.52,0-2.76-1.24-2.76-2.76V4.32c0-0.62,0.5-1.12,1.12-1.12h11.95 c0.62,0,1.12,0.5,1.12,1.12v0.71C29.1,6.56,27.87,7.8,26.34,7.8z M16.04,4.23c-0.05,0-0.09,0.04-0.09,0.09v0.71 c0,0.96,0.78,1.74,1.74,1.74h8.66c0.96,0,1.74-0.78,1.74-1.74V4.32c0-0.05-0.04-0.09-0.09-0.09H16.04z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000106832639917135823970000015702569908669804197_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M24.19,7.29v1.31c0,0.64-0.52,1.15-1.15,1.15h-2.05c-0.64,0-1.15-0.52-1.15-1.15V7.29H24.19z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M23.04,10.26h-2.05c-0.92,0-1.66-0.75-1.66-1.66V7.29c0-0.28,0.23-0.51,0.51-0.51h4.36 c0.28,0,0.51,0.23,0.51,0.51v1.31C24.7,9.51,23.96,10.26,23.04,10.26z M20.35,7.8v0.79c0,0.35,0.29,0.64,0.64,0.64h2.05 c0.35,0,0.64-0.29,0.64-0.64V7.8H20.35z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000126325262086385100720000003998290584507762364_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.81,
    y: 9.75,
    className: "st1",
    width: 2.4,
    height: 2.94
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M23.21,13.2h-2.4c-0.28,0-0.51-0.23-0.51-0.51V9.75c0-0.28,0.23-0.51,0.51-0.51h2.4 c0.28,0,0.51,0.23,0.51,0.51v2.94C23.72,12.97,23.49,13.2,23.21,13.2z M21.32,12.18h1.37v-1.92h-1.37V12.18z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M40.5,25.84c-0.64-2.45,7.47-2.24,6.73,0.19C46.64,26.86,41.05,26.71,40.5,25.84z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M46.58,26.8c-0.61-0.23-1.05-0.94-0.95-1.69c0.1-0.74,0.85-1.22,1.65-0.92c0.81,0.3,1.19,1.22,0.91,1.89 C47.9,26.76,47.2,27.03,46.58,26.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M41.01,26.8c-0.61,0.23-1.33-0.04-1.61-0.72c-0.28-0.67,0.11-1.59,0.91-1.89c0.81-0.3,1.56,0.18,1.65,0.92 C42.06,25.86,41.63,26.57,41.01,26.8z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M9.13,44.58h-3.2c-1.26,0-2.29-0.98-2.35-2.23L2.43,19.06h3.2l1.15,23.29C6.84,43.6,7.87,44.58,9.13,44.58z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M9.13,45.09h-3.2c-1.53,0-2.79-1.19-2.87-2.72L1.91,19.08c-0.01-0.14,0.04-0.28,0.14-0.38 c0.1-0.1,0.23-0.16,0.37-0.16h3.2c0.27,0,0.5,0.21,0.51,0.49l1.15,23.29c0.05,0.98,0.86,1.75,1.84,1.75 c0.28,0,0.51,0.23,0.51,0.51C9.64,44.86,9.41,45.09,9.13,45.09z M2.96,19.57l1.12,22.75c0.05,0.98,0.86,1.75,1.84,1.75h1 c-0.39-0.46-0.63-1.05-0.66-1.7l-1.12-22.8H2.96z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCleaning);
export default __webpack_public_path__ + "static/media/cleaning.9a6ac4a016178c4d689d7729e76bfb9b.svg";
export { ForwardRef as ReactComponent };